import { Wrench, Settings, Building } from "lucide-react"
import { useSiteContext } from "../context/SiteContext"

function Hero() {
  const { siteData } = useSiteContext()
  const { hero } = siteData

  const iconMap = {
    Wrench: Wrench,
    Settings: Settings,
    Building: Building
  }

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-gray-100 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Profesyonel <span className="text-blue-600">Teknik Servis</span> Hizmeti
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {hero.subtitle}
              </p>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {hero.features.map((feature, index) => {
                const IconComponent = [Wrench, Settings, Building][index] || Wrench
                return (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="bg-blue-100 p-2 rounded-lg">
                      <IconComponent className="h-5 w-5 text-blue-600" />
                    </div>
                    <span className="text-gray-700 font-medium">{feature}</span>
                  </div>
                )
              })}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/iletisim"
                className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-200"
              >
                Ücretsiz Teklif Al
              </a>
              <a
                href="/hizmetler"
                className="inline-flex items-center justify-center px-8 py-3 text-base font-medium text-blue-600 bg-transparent border border-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-200"
              >
                Hizmetlerimizi İncele
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src="/homepage.jpg"
                alt="Tesisat Ustası"
                className="w-full object-contain"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
